export enum GTINsUploaderSteps {
    UploadFile,
    Parse,
    SelectColumn,
}
